import { Component, OnInit } from '@angular/core';
import {NewLoansService} from "../new-loans.service";

@Component({
    selector: 'brightside-web-loans-main',
    templateUrl: './loans-main.component.html',
    styleUrls: ['./loans-main.component.css'],
    standalone: false
})
export class LoansMainComponent implements OnInit {

  constructor(
    private newLoansSvc: NewLoansService
  ) { }

  ngOnInit(): void {
    this.newLoansSvc.getLoanByPartnerType().subscribe();
  }

}
